import { render, staticRenderFns } from "./MemberMessage.vue?vue&type=template&id=938f25c0&scoped=true&"
import script from "./MemberMessage.vue?vue&type=script&lang=js&"
export * from "./MemberMessage.vue?vue&type=script&lang=js&"
import style0 from "./MemberMessage.vue?vue&type=style&index=0&id=938f25c0&lang=scss&scoped=true&"
import style1 from "./MemberMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938f25c0",
  null
  
)

export default component.exports